import classnames from 'classnames'
import { Component } from 'preact'
import { connect } from 'react-redux'
import { getP } from 'redux-polyglot'
import {
  KEYBOARD_LAYOUT_EXTENDED,
  KEYBOARD_LAYOUT_SPECIALS,
  KEYBOARD_LAYOUT_STANDARD,
  KEYBOARD_MODE_EMAIL,
  KEYBOARD_MODE_PHONE,
  KEYBOARD_MODE_STANDARD
} from '../constants/keyboard'
import Focusable from './focusable'
import styles from './styles/keyboard.css'

class Keyboard extends Component {

  static getDerivedStateFromProps(nextProps, prevState) {
    if ((nextProps.mode !== undefined && nextProps.mode !== prevState.mode)
      || (nextProps.layout !== undefined && nextProps.layout !== prevState.layout)
      || (nextProps.shifted !== undefined && nextProps.shifted !== prevState.shifted)) {
        return {
          mode: nextProps.mode !== undefined ? nextProps.mode : prevState.mode,
          layout: nextProps.layout !== undefined ? nextProps.layout : prevState.layout,
          shifted: nextProps.shifted !== undefined ? nextProps.shifted : prevState.shifted,
          focusedRow: nextProps.focusedRow !== undefined ? nextProps.focusedRow : prevState.focusedRow,
          focusedCol: nextProps.focusedCol !== undefined ? nextProps.focusedCol : prevState.focusedCol
        }
    }
    return null
  }

  constructor(props) {
    super(props)
    this.state = {
      mode: props.mode !== undefined ? props.mode : KEYBOARD_MODE_STANDARD,
      layout: props.layout !== undefined ? props.layout : KEYBOARD_LAYOUT_STANDARD,
      shifted: props.shifted === true,
      focusedRow: props.focusedRow !== undefined ? props.focusedRow : 0,
      focusedCol: props.focusedCol !== undefined ? props.focusedCol : 0
    }
  }

  keys = {
    1: { key: '1' },
    2: { key: '2' },
    3: { key: '3' },
    4: { key: '4' },
    5: { key: '5' },
    6: { key: '6' },
    7: { key: '7' },
    8: { key: '8' },
    9: { key: '9' },
    0: { key: '0' },

    a: { key: 'a' },
    b: { key: 'b' },
    c: { key: 'c' },
    d: { key: 'd' },
    e: { key: 'e' },
    f: { key: 'f' },
    g: { key: 'g' },
    h: { key: 'h' },
    i: { key: 'i' },
    j: { key: 'j' },
    k: { key: 'k' },
    l: { key: 'l' },
    m: { key: 'm' },
    o: { key: 'o' },
    n: { key: 'n' },
    p: { key: 'p' },
    q: { key: 'q' },
    r: { key: 'r' },
    s: { key: 's' },
    t: { key: 't' },
    u: { key: 'u' },
    v: { key: 'v' },
    w: { key: 'w' },
    x: { key: 'x' },
    y: { key: 'y' },
    z: { key: 'z' },

    A: { key: 'A' },
    B: { key: 'B' },
    C: { key: 'C' },
    D: { key: 'D' },
    E: { key: 'E' },
    F: { key: 'F' },
    G: { key: 'G' },
    H: { key: 'H' },
    I: { key: 'I' },
    J: { key: 'J' },
    K: { key: 'K' },
    L: { key: 'L' },
    M: { key: 'M' },
    O: { key: 'O' },
    N: { key: 'N' },
    P: { key: 'P' },
    Q: { key: 'Q' },
    R: { key: 'R' },
    S: { key: 'S' },
    T: { key: 'T' },
    U: { key: 'U' },
    V: { key: 'V' },
    W: { key: 'W' },
    X: { key: 'X' },
    Y: { key: 'Y' },
    Z: { key: 'Z' },

    space: { key: ' ', display: 'space', length: 3 },
    backtick: { key: '`' },
    tilde: { key: '~' },
    exclamation: { key: '!' },
    at: { key: '@' },
    at_large: { key: '@', length: 2 },
    hash: { key: '#' },
    dollar: { key: '$' },
    percent: { key: '%' },
    caret: { key: '^' },
    ampersand: { key: '&' },
    asterisk: { key: '*' },
    left_parenthesis: { key: '(' },
    right_parenthesis: { key: ')' },
    hyphen: { key: '-' },
    underscore: { key: '_' },
    equal: { key: '=' },
    plus: { key: '+' },
    left_bracket: { key: '[' },
    right_bracket: { key: ']' },
    left_brace: { key: '{' },
    right_brace: { key: '}' },
    backslash: { key: '\\' },
    pipe: { key: '|' },
    semicolon: { key: ';' },
    colon: { key: ':' },
    apostrophe: { key: "'" },
    quotation: { key: '"' },
    comma: { key: ',' },
    full_stop: { key: '.' },
    less_than: { key: '<' },
    greater_than: { key: '>' },
    slash: { key: '/' },
    question: { key: '?' },

    special1: { key: '¡' },
    special2: { key: '¿' },
    special3: { key: 'ᵃ' },
    special4: { key: '°' },
    special5: { key: '¢' },

    euro: { key: '€' },
    pound: { key: '£' },
    yen: { key: '¥' },

    extended_1: { key: 'à' },
    extended_2: { key: 'á' },
    extended_3: { key: 'â' },
    extended_4: { key: 'ã' },
    extended_5: { key: 'ä' },
    extended_6: { key: 'å' },
    extended_7: { key: 'æ' },
    extended_8: { key: 'ç' },
    extended_9: { key: 'è' },
    extended_10: { key: 'é' },
    extended_11: { key: 'ê' },
    extended_12: { key: 'ë' },
    extended_13: { key: 'ì' },
    extended_14: { key: 'í' },
    extended_15: { key: 'î' },
    extended_16: { key: 'ï' },
    extended_17: { key: 'ñ' },
    extended_18: { key: 'ò' },
    extended_19: { key: 'ó' },
    extended_20: { key: 'ô' },
    extended_21: { key: 'õ' },
    extended_22: { key: 'ö' },
    extended_23: { key: 'ø' },
    extended_24: { key: 'œ' },
    extended_25: { key: 'ß' },
    extended_26: { key: 'ù' },
    extended_27: { key: 'ú' },
    extended_28: { key: 'û' },
    extended_29: { key: 'ü' },

    extended_shifted_1: { key: 'À' },
    extended_shifted_2: { key: 'Á' },
    extended_shifted_3: { key: 'Â' },
    extended_shifted_4: { key: 'Ã' },
    extended_shifted_5: { key: 'Ä' },
    extended_shifted_6: { key: 'Å' },
    extended_shifted_7: { key: 'Æ' },
    extended_shifted_8: { key: 'Ç' },
    extended_shifted_9: { key: 'È' },
    extended_shifted_10: { key: 'É' },
    extended_shifted_11: { key: 'Ê' },
    extended_shifted_12: { key: 'Ë' },
    extended_shifted_13: { key: 'Ì' },
    extended_shifted_14: { key: 'Í' },
    extended_shifted_15: { key: 'Î' },
    extended_shifted_16: { key: 'Ï' },
    extended_shifted_17: { key: 'Ñ' },
    extended_shifted_18: { key: 'Ò' },
    extended_shifted_19: { key: 'Ó' },
    extended_shifted_20: { key: 'Ô' },
    extended_shifted_21: { key: 'Õ' },
    extended_shifted_22: { key: 'Ö' },
    extended_shifted_23: { key: 'Ø' },
    extended_shifted_24: { key: 'Œ' },
    extended_shifted_25: { key: 'ß' },
    extended_shifted_26: { key: 'Ù' },
    extended_shifted_27: { key: 'Ú' },
    extended_shifted_28: { key: 'Û' },
    extended_shifted_29: { key: 'Ü' },

    email_1: { key: '.com', length: 2 },
    email_2: { key: '.ca', length: 2 },
    email_3: { key: '.net', length: 2 },
    email_4: { key: '.edu', length: 2 },
    email_5: { key: '.org', length: 2 },
    email_6: { key: '.gov', length: 2 },
    email_7: { key: '@yahoo.com', length: 3 },
    email_8: { key: '@gmail.com', length: 4 },
    email_9: { key: '@hotmail.com', length: 3 },

    shift: { action: 'shift', display: '&#8679;', length: 2 },
    unshift: { action: 'unshift', display: '&#8679;', length: 2, className: 'btnFlip' },
    shift_extended: { action: 'shift', display: '&#8679;' },
    unshift_extended: { action: 'unshift', display: '&#8679;', className: 'btnFlip' },
    specials: { action: 'specials', display: '!#$', length: 2},
    extend: { action: 'extend', display: 'àáâ', length: 2},
    extend_shifted: { action: 'extend', display: 'ÀÁÂ', length: 2},
    standard: { action: 'standard', display: 'abc', length: 2},
    standard_shifted: { action: 'standard', display: 'ABC', length: 2},
    delete: { action: 'delete', display: 'delete', displayPrefix: '← ', length: 3 }
  }

  layouts = {
    standard: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
      ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'hyphen'],
      ['shift', 'z', 'x', 'c', 'v', 'b', 'n', 'm', 'apostrophe'],
      ['specials', 'extend', 'space', 'delete']
    ],
    standard_shifted: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
      ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'hyphen'],
      ['unshift', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', 'apostrophe'],
      ['specials', 'extend_shifted', 'space', 'delete']
    ],
    specials: [
      ['backtick', 'tilde', 'exclamation', 'at', 'hash', 'dollar', 'percent', 'caret', 'ampersand', 'asterisk'],
      ['left_parenthesis', 'right_parenthesis', 'hyphen', 'underscore', 'equal', 'plus', 'left_bracket', 'right_bracket', 'left_brace', 'right_brace'],
      ['backslash', 'pipe', 'semicolon', 'colon', 'apostrophe', 'quotation', 'comma', 'full_stop', 'less_than', 'greater_than'],
      ['slash', 'question', 'special1', 'special2', 'special3', 'special4', 'special5', 'euro', 'dollar', 'yen'],
      ['standard', 'extend', 'space', 'delete']
    ],
    specials_shifted: [
      ['backtick', 'tilde', 'exclamation', 'at', 'hash', 'dollar', 'percent', 'caret', 'ampersand', 'asterisk'],
      ['left_parenthesis', 'right_parenthesis', 'hyphen', 'underscore', 'equal', 'plus', 'left_bracket', 'right_bracket', 'left_brace', 'right_brace'],
      ['backslash', 'pipe', 'semicolon', 'colon', 'apostrophe', 'quotation', 'comma', 'full_stop', 'less_than', 'greater_than'],
      ['slash', 'question', 'special1', 'special2', 'special3', 'special4', 'special5', 'euro', 'dollar', 'yen'],
      ['standard_shifted', 'extend_shifted', 'space', 'delete']
    ],
    extended: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['extended_1', 'extended_2', 'extended_3', 'extended_4', 'extended_5', 'extended_6', 'extended_7', 'extended_8', 'extended_9', 'extended_10'],
      ['extended_11', 'extended_12', 'extended_13', 'extended_14', 'extended_15', 'extended_16', 'extended_17', 'extended_18', 'extended_19', 'extended_20'],
      ['shift_extended', 'extended_21', 'extended_22', 'extended_23', 'extended_24', 'extended_25', 'extended_26', 'extended_27', 'extended_28', 'extended_29'],
      ['specials', 'standard', 'space', 'delete']
    ],
    extended_shifted: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['extended_shifted_1', 'extended_shifted_2', 'extended_shifted_3', 'extended_shifted_4', 'extended_shifted_5', 'extended_shifted_6', 'extended_shifted_7', 'extended_shifted_8', 'extended_shifted_9', 'extended_shifted_10'],
      ['extended_shifted_11', 'extended_shifted_12', 'extended_shifted_13', 'extended_shifted_14', 'extended_shifted_15', 'extended_shifted_16', 'extended_shifted_17', 'extended_shifted_18', 'extended_shifted_19', 'extended_shifted_20'],
      ['unshift_extended', 'extended_shifted_21', 'extended_shifted_22', 'extended_shifted_23', 'extended_shifted_24', 'extended_shifted_25', 'extended_shifted_26', 'extended_shifted_27', 'extended_shifted_28', 'extended_shifted_29'],
      ['specials', 'standard_shifted', 'space', 'delete']
    ],
    email: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
      ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'hyphen'],
      ['shift', 'z', 'x', 'c', 'v', 'b', 'n', 'm', 'underscore'],
      ['email_7', 'email_8', 'email_9'],
      ['specials', 'at_large', 'full_stop', 'email_1', 'delete']
    ],
    email_shifted: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
      ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'hyphen'],
      ['unshift', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', 'underscore'],
      ['email_7', 'email_8', 'email_9'],
      ['specials', 'at_large', 'full_stop', 'email_1', 'delete']
    ],
    email_specials: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['backtick', 'tilde', 'exclamation', 'at', 'hash', 'dollar', 'percent', 'caret', 'ampersand', 'asterisk'],
      ['plus', 'hyphen', 'underscore', 'left_brace', 'right_brace', 'pipe', 'apostrophe', 'full_stop', 'slash', 'question'],
      ['email_2', 'email_3', 'email_4', 'email_5', 'email_6'],
      ['email_7', 'email_8', 'email_9'],
      ['standard', 'at_large', 'full_stop', 'email_1', 'delete']
    ],
    email_specials_shifted: [
      ['backtick', 'tilde', 'exclamation', 'at', 'hash', 'dollar', 'percent', 'caret', 'ampersand', 'asterisk'],
      ['left_parenthesis', 'right_parenthesis', 'hyphen', 'underscore', 'equal', 'plus', 'left_bracket', 'right_bracket', 'left_brace', 'right_brace'],
      ['backslash', 'pipe', 'semicolon', 'colon', 'apostrophe', 'quotation', 'comma', 'full_stop', 'less_than', 'greater_than'],
      ['slash', 'question', 'special1', 'special2', 'special3', 'special4', 'special5', 'euro', 'dollar', 'yen'],
      ['standard_shifted', 'extend_shifted', 'space', 'delete']
    ],
    phone: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
      ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'hyphen'],
      ['shift', 'z', 'x', 'c', 'v', 'b', 'n', 'm', 'plus'],
      ['specials', 'extend', 'space', 'delete']
    ],
    phone_shifted: [
      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
      ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'hyphen'],
      ['unshift', 'Z', 'X', 'C', 'V', 'B', 'N', 'M', 'plus'],
      ['specials', 'extend_shifted', 'space', 'delete']
    ]
  }

  handleClick = (row, col) => event => {
    const key = this.convertKey(this.getKeyByPosition(row, col))
    if (typeof key.action === 'function') {
      if (!key.disabled) {
        key.action(event)
      }
    } else {
      switch(key.action) {
        case 'shift':
          event.preventDefault()
          event.stopPropagation()
          this.setState({
            ...this.state,
            shifted: true,
            focusedRow: row,
            focusedCol: col
          })
          break
        case 'unshift':
          event.preventDefault()
          event.stopPropagation()
          this.setState({
            ...this.state,
            shifted: false,
            focusedRow: row,
            focusedCol: col
          })
          break
        case 'specials':
          event.preventDefault()
          event.stopPropagation()
          this.setState({
            ...this.state,
            layout: KEYBOARD_LAYOUT_SPECIALS,
            focusedRow: row,
            focusedCol: col
          })
          break
        case 'extend':
          event.preventDefault()
          event.stopPropagation()
          this.setState({
            ...this.state,
            layout: KEYBOARD_LAYOUT_EXTENDED,
            focusedRow: row,
            focusedCol: col
          })
          break
        case 'standard':
          event.preventDefault()
          event.stopPropagation()
          this.setState({
            ...this.state,
            layout: KEYBOARD_LAYOUT_STANDARD,
            focusedRow: row,
            focusedCol: col
          })
          break
        default:
          this.setState({
            ...this.state,
            focusedRow: row,
            focusedCol: col
          })
          this.props.handleKeyDown(event, key)
      }
    }
  }

  handleKeyDown = (row, col) => event => {
    if (event.key === 'Enter' || event.keyCode === 0x0D) {
      event.preventDefault()
      event.stopPropagation()
      this.handleClick(row, col)(event)
    } else if (event.key === 'ArrowLeft' || event.keyCode === 0x25) {
      event.preventDefault()
      event.stopPropagation()
      this.handleFocusLeft(row, col)
    } else if (event.key === 'ArrowRight' || event.keyCode === 0x27) {
      event.preventDefault()
      event.stopPropagation()
      this.handleFocusRight(row, col)
    } else if (event.key === 'ArrowUp' || event.keyCode === 0x26) {
      event.preventDefault()
      event.stopPropagation()
      this.handleFocusUp(row, col)
    } else if (event.key === 'ArrowDown' || event.keyCode === 0x28) {
      event.preventDefault()
      event.stopPropagation()
      this.handleFocusDown(row, col)
    } else if (event.key === 'Tab' || event.keyCode === 0x09) {
      this.props.handleTab(event)
    } else {
      this.handlePhysicalKeyDown(event)
    }
  }

  handlePhysicalKeyDown = event => {
    switch(this.state.mode) {
      case KEYBOARD_MODE_EMAIL:
        if (!this.activateKeyByPositionInLayout(event, this.layouts.email, false, KEYBOARD_LAYOUT_STANDARD)) {
          if (!this.activateKeyByPositionInLayout(event, this.layouts.email_shifted, true, KEYBOARD_LAYOUT_STANDARD)) {
            if (!this.activateKeyByPositionInLayout(event, this.layouts.email_specials, false, KEYBOARD_LAYOUT_SPECIALS)) {
              if (!this.activateKeyByPositionInLayout(event, this.layouts.email_specials_shifted, true, KEYBOARD_LAYOUT_SPECIALS)) {
                // give up
              }
            }
          }
        }
        break
      case KEYBOARD_MODE_PHONE:
        if (!this.activateKeyByPositionInLayout(event, this.layouts.phone, false, KEYBOARD_LAYOUT_STANDARD)) {
          if (!this.activateKeyByPositionInLayout(event, this.layouts.phone_shifted, true, KEYBOARD_LAYOUT_STANDARD)) {
            if (!this.activateKeyByPositionInLayout(event, this.layouts.extended, false, KEYBOARD_LAYOUT_EXTENDED)) {
              if (!this.activateKeyByPositionInLayout(event, this.layouts.extended_shifted, true, KEYBOARD_LAYOUT_EXTENDED)) {
                if (!this.activateKeyByPositionInLayout(event, this.layouts.specials, false, KEYBOARD_LAYOUT_SPECIALS)) {
                  if (!this.activateKeyByPositionInLayout(event, this.layouts.specials_shifted, true, KEYBOARD_LAYOUT_SPECIALS)) {
                    // give up
                  }
                }
              }
            }
          }
        }
        break
      case KEYBOARD_MODE_STANDARD:
      default:
        if (!this.activateKeyByPositionInLayout(event, this.layouts.standard, false, KEYBOARD_LAYOUT_STANDARD)) {
          if (!this.activateKeyByPositionInLayout(event, this.layouts.standard_shifted, true, KEYBOARD_LAYOUT_STANDARD)) {
            if (!this.activateKeyByPositionInLayout(event, this.layouts.extended, false, KEYBOARD_LAYOUT_EXTENDED)) {
              if (!this.activateKeyByPositionInLayout(event, this.layouts.extended_shifted, true, KEYBOARD_LAYOUT_EXTENDED)) {
                if (!this.activateKeyByPositionInLayout(event, this.layouts.specials, false, KEYBOARD_LAYOUT_SPECIALS)) {
                  if (!this.activateKeyByPositionInLayout(event, this.layouts.specials_shifted, true, KEYBOARD_LAYOUT_SPECIALS)) {
                    // give up
                  }
                }
              }
            }
          }
        }
    }
  }

  activateKeyByPositionInLayout = (event, layout, shifted, layoutName) => {
    let eventKey
    if (event.key === undefined || event.key === 'Unidentified') {
      switch(event.keyCode) {
        case 48:
          eventKey = '0'
          break
        case 49:
          eventKey = '1'
          break
        case 50:
          eventKey = '2'
          break
        case 51:
          eventKey = '3'
          break
        case 52:
          eventKey = '4'
          break
        case 53:
          eventKey = '5'
          break
        case 54:
          eventKey = '6'
          break
        case 55:
          eventKey = '7'
          break
        case 56:
          eventKey = '8'
          break
        case 57:
          eventKey = '9'
          break
        case 0x1ce: /* Menu key on the MediaTek remote controls */
          eventKey = 'Backspace' 
          break
        case 0x1cd: /* Back key on the LG WebOS 3.x devices */
          eventKey = 'Backspace' 
          break
        default:
          return false
      }
    } else {
      eventKey = event.key
    }
    for (let row = 0; row < layout.length; row++) {
      for (let col = 0; col < layout[row].length; col++) {
        const fullKey = this.keys[layout[row][col]]
        if (((eventKey === 'Backspace' || eventKey === 'Escape' ||
                eventKey === 'RCUBack' || eventKey === 'Delete' ||
                eventKey === 'XF86Back') &&
              fullKey.action === 'delete') ||
            (fullKey.eventKey !== undefined && fullKey.eventKey === eventKey) ||
            (fullKey.key === eventKey)
        ) {
          if (fullKey.action === 'delete' && !!this.props.shouldHandleDelete || fullKey.action !== 'delete') {
            this.activateKey(row, col, shifted, layoutName)
          }
          this.props.handleKeyDown(event, fullKey)
          return true
        }
      }
    }
    return false
  }

  activateKey = (row, col, shifted, layout) => {
    this.setState({
      ...this.state,
      layout: layout,
      shifted: shifted,
      focusedRow: row,
      focusedCol: col
    })
  }

  handleFocusUp = (row, col) => {
    let newRow = row - 1
    if (newRow >= 0) {
      this.setState({
        ...this.state,
        focusedRow: newRow,
        focusedCol: this.getNewCol(row, newRow, col)
      })
    } else if (this.props.handleFocusUp) {
      this.props.handleFocusUp()
    }
  }
  handleFocusDown = (row, col) => {
    const layout = this.getLayout()
    let newRow = row + 1
    if (newRow < layout.length) {
      this.setState({
        ...this.state,
        focusedRow: newRow,
        focusedCol: this.getNewCol(row, newRow, col)
      })
    } else if (this.props.handleFocusDown) {
      this.props.handleFocusDown()
    }
  }
  handleFocusLeft = (row, col) => {
    let newCol = --col
    if (newCol >= 0) {
      this.setState({
        ...this.state,
        focusedCol: newCol
      })
    } else if (this.props.handleFocusLeft) {
      this.props.handleFocusLeft()
    }
  }
  handleFocusRight = (row, col) => {
    const layout = this.getLayout()
    let newCol = ++col
    if (newCol < layout[row].length) {
      this.setState({
        ...this.state,
        focusedCol: newCol
      })
    } else if (this.props.handleFocusRight) {
      this.props.handleFocusRight()
    }
  }

  getFocusedPosition = (layout) => {

      const currentLayout = layout !== undefined ? layout : this.getLayout()

      let newRow = this.state.focusedRow === -1
        ? currentLayout.length - 1
        : this.state.focusedRow
      if (newRow > currentLayout.length - 1) {
        newRow = currentLayout.length - 1
      } else if (newRow < 0) {
        newRow = 0
      }

      let newCol = this.state.focusedCol === -1
        ? currentLayout[newRow].length - 1
        : this.state.focusedCol
      if (newCol > currentLayout[newRow].length - 1) {
        newCol = currentLayout[newRow].length - 1
      } else if (newCol < 0) {
        newCol = 0
      }

      return {
        focusedRow: newRow,
        focusedCol: newCol
      }
  }

  isFocused = (row, col, focusedPosition) => {
    const { focusedRow, focusedCol } = focusedPosition
    return row === focusedRow && col === focusedCol
  }

  getLayout = () => {
    let layout
    switch(this.state.mode) {
      case KEYBOARD_MODE_EMAIL:
        switch(this.state.layout) {
          case KEYBOARD_LAYOUT_SPECIALS:
            layout = this.state.shifted ? [ ...this.layouts.email_specials_shifted ] : [ ...this.layouts.email_specials ]
            break
          case KEYBOARD_LAYOUT_STANDARD:
          default:
            layout = this.state.shifted ? [ ...this.layouts.email_shifted ] : [ ...this.layouts.email ]
        }
        break
      case KEYBOARD_MODE_PHONE:
        switch(this.state.layout) {
          case KEYBOARD_LAYOUT_EXTENDED:
            layout = this.state.shifted ? [ ...this.layouts.extended_shifted ] : [ ...this.layouts.extended ]
            break
          case KEYBOARD_LAYOUT_SPECIALS:
            layout = this.state.shifted ? [ ...this.layouts.specials_shifted ] : [ ...this.layouts.specials ]
            break
          case KEYBOARD_LAYOUT_STANDARD:
          default:
            layout = this.state.shifted ? [ ...this.layouts.phone_shifted ] : [ ...this.layouts.phone ]
        }
        break
      case KEYBOARD_MODE_STANDARD:
      default:
        switch(this.state.layout) {
          case KEYBOARD_LAYOUT_EXTENDED:
            layout = this.state.shifted ? [ ...this.layouts.extended_shifted ] : [ ...this.layouts.extended ]
            break
          case KEYBOARD_LAYOUT_SPECIALS:
            layout = this.state.shifted ? [ ...this.layouts.specials_shifted ] : [ ...this.layouts.specials ]
            break
          case KEYBOARD_LAYOUT_STANDARD:
          default:
            layout = this.state.shifted ? [ ...this.layouts.standard_shifted ] : [ ...this.layouts.standard ]
        }
    }
    layout.push(this.props.actions)
    return layout
  }

  getKeyByPosition = (row, col) => {
    const layout = this.getLayout()
    if (row > layout.length) {
      row = layout.length
    }
    if (col > layout[row].length) {
      col = layout[row].length
    }
    return layout[row][col]
  }

  convertKey = (keyIndex) => {
    if (typeof keyIndex === 'object') {
      return keyIndex
    }
    return this.keys[keyIndex]
  }

  getNewCol = (oldRow, newRow, oldCol) => {
    const layout = this.getLayout()
    let position = 0
    for (let i = 0; i < oldCol; i++) {
      const key = this.convertKey(layout[oldRow][i])
      if (typeof key.length !== 'undefined') {
        position += key.length
      } else {
        position++
      }
    }
    let newCol = 0
    let targetPosition = 0
    for (let i = 0; i < layout[newRow].length; i++) {
      const key = this.convertKey(layout[newRow][i])
      if (typeof key.length !== 'undefined') {
        targetPosition += key.length
      } else {
        targetPosition++
      }
      if (targetPosition > position) {
        newCol = i
        break
      }
    }
    return newCol
  }

  render({ polyglot: { t } }) {
    const currentLayout = this.getLayout()
    const focusedPosition = this.getFocusedPosition(currentLayout)
    return (
      <div class={styles.keyboardComponent}>
        <div class={classnames(styles.title, { [styles.titleError]: this.props.titleError })}>
          {this.props.title}
        </div>
        {currentLayout.map((currentRow, rowIndex) => {
          return <div class={classnames(styles.kbdRow, { [styles.kbdRowActions]: rowIndex === currentLayout.length - 1 })}>
            {currentRow.map((currentKey, colIndex) => {
              const key = this.convertKey(currentKey)
              return (
                <div
                  class={classnames(styles.btnWrapper, {
                    [styles.btnSize2x]: key.length === 2,
                    [styles.btnSize3x]: key.length === 3,
                    [styles.btnSize4x]: key.length === 4,
                    [styles.btnSize5x]: key.length === 5,
                    [styles.btnDisabled]: key.disabled
                  })}>
                  <Focusable
                    class={classnames(styles.btn, key.className)}
                    isFocused={this.props.focused && this.isFocused(rowIndex, colIndex, focusedPosition)}
                    onClick={this.handleClick(rowIndex, colIndex)}
                    onKeyDown={this.handleKeyDown(rowIndex, colIndex)}
                    dangerouslySetInnerHTML={{__html: '<span>' + (typeof key.display !== 'undefined' ? (typeof key.displayPrefix !== 'undefined' ? key.displayPrefix : '') + t(`tv_app.keyboard_key_${key.display}`, { _: key.display }) : key.key) + '</span>'}}>
                  </Focusable>
                </div>
              )
            })}
          </div>
        })}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  polyglot: getP(state)
})

export default connect(mapStateToProps)(Keyboard)
